const fontMain = getComputedStyle(document.body).getPropertyValue('--font').trim();

const colorMain = getComputedStyle(document.body).getPropertyValue('--brand').trim();
const colorAlt1 = getComputedStyle(document.body).getPropertyValue('--brand-alt1').trim();
const colorAlt2 = getComputedStyle(document.body).getPropertyValue('--brand-alt2').trim();
const colorAlt3 = getComputedStyle(document.body).getPropertyValue('--brand-alt3').trim();
const colorAlt4 = getComputedStyle(document.body).getPropertyValue('--brand-alt4').trim();

const colorChart1 = getComputedStyle(document.body).getPropertyValue('--chart1').trim();
const colorChart2 = getComputedStyle(document.body).getPropertyValue('--chart2').trim();
const colorChart3 = getComputedStyle(document.body).getPropertyValue('--chart3').trim();
const colorChart4 = getComputedStyle(document.body).getPropertyValue('--chart4').trim();
const colorChart5 = getComputedStyle(document.body).getPropertyValue('--chart5').trim();


export const fonts = {
  main: fontMain,
};

export const colors = {
  main: colorMain,
  alt1: colorAlt1,
  alt2: colorAlt2,
  alt3: colorAlt3,
  alt4: colorAlt4,
  chart: {
    first: colorChart1,
    second: colorChart2,
    third: colorChart3,
    fourth: colorChart4,
    fifth: colorChart5,
  },
};
